<style lang="scss" scoped>
    .base-warp{
        display: flex;
        .source-warp{
            width: 50%;height: 300px;
            padding: 15px;
            padding-left: 0;
        }
        .tran-warp{
            flex: 1;
            height: 300px;
            padding: 15px;
            padding-right: 0;
            
        }
    }
</style>
<template>
    <div>
        <Divider orientation="center">翻译测试</Divider>
        <div>
            <span><small>会员组:</small> {{userInfo.memberGroup.name}}</span>
            <span style="margin-left:15px"><small>会员类型:</small> {{userInfo.memberGroup.translationBillingMode == 'time' ? '包月用户' : '字符用户'}}</span>
            <span style="margin-left:15px">
                <small>翻译渠道:</small> 
                <TranslateChannelLabel :tranChannelId="userInfo.tranChannelId"/>
            </span>
        </div>
        <div class="base-warp">
            <div class="source-warp">
                <div style="margin-bottom:5px">
                    <Select placeholder="请选择原文语种" filterable v-model="formData.source">
                        <Option v-for="item in sourceList" :key="item.id" :value="item.langCode">
                            {{item.chineseName}}
                        </Option>
                    </Select>
                </div>
                <Input show-word-limit :rows="10" type="textarea" v-model="formData.text" />
            </div>
            <div class="tran-warp">
                <div style="margin-bottom:5px">
                <Select placeholder="请选择翻译语种" filterable v-model="formData.target">
                    <Option v-for="item in targetList" :key="item.id" :value="item.langCode">
                        {{item.chineseName}}
                    </Option>
                </Select>
                </div>
                <Input readonly v-model="tranText" :rows="10" type="textarea" />
                    
            </div>
        </div>
        <div style="padding:15px;text-align: center;">
            <Button long size="large" :loading="loading" type="primary" @click="tran">翻译测试</Button>
        </div>
    </div>
</template>

<script>
    import userService from "@/service/user"
    import translationService from "@/service/translation"
    export default {
        name: 'UserCenterChangeTranslateTest',
        data() {
            return {
                userInfo: {
                    memberGroup:{}
                },
                loading: false,
                sourceList : [],
                targetList : [],
                tranText:"",
                formData: {
                    source:"",
                    target:"",
                    text:""
                }
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                this.loadUserInfo();
                this.loadData();
            },
            async loadUserInfo(){
                let userInfo = await userService.get();
                this.userInfo = userInfo;
            },
            async loadData(){
                let res = await translationService.list();
                this.sourceList = res.sourceList;
                this.targetList = res.targetList;
                console.log(res)
            },
            async tran(){
                this.loading = true;
                let params = this.formData;
                let res = await translationService.text(params);
                this.loading = false;
                if(!res){
                    return;
                }
                this.$Message.success("翻译成功")
                this.tranText = res.translated;
            }
        }
    }
</script>

